export default __webpack_public_path__ + "static/media/ic-eye.1b646788.svg";